import { ResponseBase } from './ResponseBase';

export class ResponseTeachingScheduleList extends ResponseBase{
    Data: any;
}
export class ResponseDiemDanhChiTiet extends ResponseBase{
    Data: any;
}

